import { render, staticRenderFns } from "./materialCard.vue?vue&type=template&id=252a61f1&scoped=true&"
import script from "./materialCard.vue?vue&type=script&lang=js&"
export * from "./materialCard.vue?vue&type=script&lang=js&"
import style0 from "./materialCard.vue?vue&type=style&index=0&id=252a61f1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252a61f1",
  null
  
)

export default component.exports